/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_SuggestedInputs */

const en_pwf_suggested = /** @type {(inputs: Pwf_SuggestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested`)
};

const de_pwf_suggested = /** @type {(inputs: Pwf_SuggestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgeschlagen`)
};

/**
* | output |
* | --- |
* | "Suggested" |
*
* @param {Pwf_SuggestedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_suggested = /** @type {((inputs?: Pwf_SuggestedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_SuggestedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_suggested(inputs)
	return en_pwf_suggested(inputs)
});